<script setup>
  import { computed } from 'vue';
  import TideSpotSelectorButton from '@/components/TideSpotSelectorButton.vue';

  const emits = defineEmits(['open:modalTideSpotSelector']);

  const props = defineProps({
    selectedTideSpot: {
      type: Object,
      required: true
    },
    hasCurrentsSpot: {
      type: Boolean,
      required: true
    }
  });

  const selectorButtonProps = computed(() => ({
    tideSpot: props.selectedTideSpot,
    hasCurrentsSpot: props.hasCurrentsSpot
  }));

  function handleSelectorButtonClick() {
    emits('open:modalTideSpotSelector');
  };

</script>

<template>
  <TideSpotSelectorButton
    @click="handleSelectorButtonClick"
    v-bind="selectorButtonProps"
  />
</template>